import { render } from "./province-delete.vue?vue&type=template&id=168248a2"
import script from "./province-delete.vue?vue&type=script&lang=js"
export * from "./province-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__